import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, XCircle, Smartphone, Users, MessageSquareOff } from 'lucide-react';
export function Problem() {
  return <section className="bg-brand-dark px-6 py-20 md:py-28" data-id="element-185">
      <div className="mx-auto max-w-4xl" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 text-center" data-id="element-187">
          <p className="text-xl md:text-2xl font-medium leading-relaxed text-slate-300 italic border-l-4 border-brand-gold pl-6 text-left mb-12" data-id="element-188">
            "Si estás leyendo esto, probablemente ya pasaste por el momento más
            incómodo del Network Marketing:{' '}
            <span className="text-white font-bold" data-id="element-189">
              quedarte sin gente a quién hablarle.
            </span>
            "
          </p>

          <p className="text-lg text-slate-400 text-left mb-16" data-id="element-190">
            Has publicado Reels que nadie ve, has enviado mensajes en frío que
            terminan en "visto" y sientes que tu negocio se estanca porque no
            sabes cómo llenar tu agenda sin molestar a tus amigos de la
            secundaria.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="rounded-2xl bg-brand-light border border-slate-800 p-8 md:p-12 mb-20" data-id="element-191">
          <div className="flex items-center gap-4 mb-6" data-id="element-192">
            <div className="bg-red-500/10 p-3 rounded-lg" data-id="element-193">
              <AlertCircle className="w-8 h-8 text-red-500" data-id="element-194" />
            </div>
            <h2 className="text-3xl font-bold text-white" data-id="element-195">
              El problema no es tu empresa...
            </h2>
          </div>

          <p className="text-lg text-slate-300 mb-6" data-id="element-196">
            Ni tu producto, ni tu plan de compensación. El problema es que{' '}
            <strong className="text-white" data-id="element-197">
              te enseñaron a "cazar" cuando deberías estar aprendiendo a
              "atraer".
            </strong>
          </p>

          <p className="text-lg text-slate-300" data-id="element-198">
            La mayoría de los Networkers cometen el error de convertir su
            Instagram en un catálogo de productos aburrido o en un diario de
            frases motivacionales genéricas. Eso no recluta. Eso aleja. Estás
            gastando energía en estrategias de 1990 para un mundo de 2026.
          </p>
        </motion.div>

        <div className="space-y-12" data-id="element-199">
          <div className="text-center mb-10" data-id="element-200">
            <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-201">
              Por qué lo que has intentado NO funciona
            </h3>
            <div className="w-20 h-1 bg-brand-gold mx-auto mt-4 rounded-full" data-id="element-202"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-203">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-brand-darker border border-slate-800 rounded-xl p-6 relative overflow-hidden" data-id="element-204">
              <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-205">
                <Smartphone className="w-24 h-24 text-white" data-id="element-206" />
              </div>
              <XCircle className="w-8 h-8 text-red-500 mb-4" data-id="element-207" />
              <h4 className="text-xl font-bold text-white mb-3" data-id="element-208">
                Publicar por publicar
              </h4>
              <p className="text-slate-400" data-id="element-209">
                Subir fotos del producto sin una estrategia de "Gancho" solo te
                hace ver como un spammer más.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-brand-darker border border-slate-800 rounded-xl p-6 relative overflow-hidden" data-id="element-210">
              <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-211">
                <Users className="w-24 h-24 text-white" data-id="element-212" />
              </div>
              <XCircle className="w-8 h-8 text-red-500 mb-4" data-id="element-213" />
              <h4 className="text-xl font-bold text-white mb-3" data-id="element-214">
                Cursos de "Influencers"
              </h4>
              <p className="text-slate-400" data-id="element-215">
                Te enseñan a ganar likes y seguidores, pero los likes no pagan
                las facturas ni construyen líneas de auspicio.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-brand-darker border border-slate-800 rounded-xl p-6 relative overflow-hidden" data-id="element-216">
              <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-217">
                <MessageSquareOff className="w-24 h-24 text-white" data-id="element-218" />
              </div>
              <XCircle className="w-8 h-8 text-red-500 mb-4" data-id="element-219" />
              <h4 className="text-xl font-bold text-white mb-3" data-id="element-220">
                Mensajes en frío masivos
              </h4>
              <p className="text-slate-400" data-id="element-221">
                Rogar por una presentación de 1 a 1 destruye tu postura y tu
                autoridad frente al prospecto.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}